__turbopack_context__.v({
  "clickableIcon": "PageNavigation-module-scss-module__kh5Z4G__clickableIcon",
  "notClickable": "PageNavigation-module-scss-module__kh5Z4G__notClickable",
  "notClickableIcon": "PageNavigation-module-scss-module__kh5Z4G__notClickableIcon",
  "pagers": "PageNavigation-module-scss-module__kh5Z4G__pagers",
});
